// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { jsonToBase64, stringToBase64 } from '@imprivata-cloud/dataprivacy';
import { _getUrl } from './api/utils';

export const stringToBase64Url = (str: string): string => {
  return base64toBase64Url(stringToBase64(str));
};

export const jsonToBase64Url = (obj: Record<string, unknown>): string => {
  return base64toBase64Url(jsonToBase64(obj));
};

// base64Url is a variant of base64 that is URL and filename safe.
// All it does differently is omitting padding '=' and replacing '+' -> '-' and '/' -> '_'.
export const base64toBase64Url = (str: string): string => {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const getUrlParam = (param: string): string | null => {
  return new URLSearchParams(window.location.search).get(param);
};

export const getIDPUrl = (tenantId: string, workflowId: string) => {
  const urls = _getUrl({
    idpUrl: { sub: `${tenantId}.sys`, path: '/idp-web/idp/authenticate' },
    portalUrl: { sub: `${tenantId}.access`, path: '/' },
  });
  const idpUrl = urls?.idpUrl;
  const targetQueryParam = getUrlParam('target');
  let targetUrl = `${urls?.portalUrl}?tenantId=${tenantId}`;
  if (targetQueryParam) {
    const targetUrlWithTenantId = getUrlWithTenantId(
      targetQueryParam,
      tenantId,
    );
    targetUrl = `${targetUrlWithTenantId}`;
  }
  const idpQueryParams = `?workflowId=${workflowId}&target=${targetUrl}`;
  console.log(`IDP URL: ${idpUrl}${idpQueryParams}`);
  return `${idpUrl}${idpQueryParams}`;
};

/**
 * TODO Needs to be moved to common
 */
export function getUrlWithTenantId(url: string, tenantId: string): string {
  const urlObj = new URL(url);
  // Split the hostname into parts
  const parts = urlObj.hostname.split('.');

  // Identify common domain patterns
  const domainParts = 2; // e.g., imprivata.com, imprivata.cloud, imprivata.eu
  const envPart = parts.some(part => /^(dev|int|stg|eph)(\d+)?$/.test(part))
    ? 1
    : 0;
  const appPart = parts.some(part => part === 'app') ? 1 : 0;
  // Standard URL has: service + optional app + optional env + domain
  const standardParts = 1 + appPart + envPart + domainParts;

  // If we have more parts than the standard pattern, assume the first is a tenant ID - already exists
  if (parts.length > standardParts) {
    return url;
  }
  urlObj.hostname = `${tenantId}.${urlObj.hostname}`;
  return urlObj.toString();
}
